/* eslint-disable no-console */
import React from 'react';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { createSafeDynamicRegex } from '../../utils/library';
import { makeApiCall } from '../../redux/actions/common/common-action';

import Styled from 'styled-components';
import { MiniLoader } from '../minLoader';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import {
  CARTES_CARD_ICON,
  GREY_DOWN_ARROW_ICON,
  MASTERCARD_SMALL_ICON,
  VISA_CARD_SVG_ICON
} from '@Images';
import { logEventV2 } from '@Utils/events/logUserEvents';
import { EventItemSection, EventNamesV2 } from '@Utils/events/eventsConstants';
import { CountryFlagName } from '@Commons';

// Images are added for only Card network
const cardsImage = {
  MASTERCARD: MASTERCARD_SMALL_ICON,
  VISA: VISA_CARD_SVG_ICON,
  CARTES_BANCAIRES: CARTES_CARD_ICON
};

const BoxContainer = Styled.div`
        ${(p) => p.maxWidth && `max-width: ${p.maxWidth}`};
        ${(p) =>
          p.isSingleRowField ? 'width: 100%' : p.width ? `width: ${p.width}` : 'width: 325px'};
        height:50px;
        margin-top:8px;
        margin-left:${(p) => (p.$marginLeft ? p.$marginLeft : '')};
        @media only screen and (max-width: 1024px) {
        height:${(p) => (p.$chekError ? 'auto' : '')};
        margin-left:${(p) => (p.$marginLeft ? p.$marginLeft : '')};
        margin-bottom:8px;
        width:${(p) => (p.width ? p.width : '323px')};
        display:flex;
        flex-direction: column;
    }
        .error{
        margin-left: 5px;
        font-size: 0.68rem;
        margin-top: 3px;
        text-align: left;
        font-family: ${FONT_FAMILY.hellix.regular};
        font-weight: 400;
        line-height: 1.66;
        letter-spacing: 0.03333em;
        color:red;
        margin-bottom:10px;
        }

`;
const Label = Styled.label`
    object-fit: contain;
    padding: 0 17px;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: ${(p) => (p.$isFocused || p.value ? '14px' : `16px`)};
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: ${(p) => (p.$isFocused || p.value ? '18px' : `22px`)};
    letter-spacing: normal;
    padding-left:3px;
    background-color: #FFFF;
    box-sizing: content-box;
    color: ${(p) => (p.$errorBorder ? 'red' : p.$isFocused ? '#000' : `#747474`)};
    position: absolute;
    z-index:  ${(p) => (p.$isFocused ? 19 : p.value ? 11 : 0)};
    transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    transform: ${(p) =>
      p.$isFocused || p.value
        ? `translate(10px, -7px) scale(0.86)`
        : `translate(9px, 16px) scale(1)`};
`;
const OutlinedDropdown = Styled(Dropdown)`
                width:100%;
                border-radius: 3px;            
                background-color: ${COLORS.white};
                position: relative;
                font-family: ${FONT_FAMILY.hellix.regular};
            >input {
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color:  ${COLORS.black};
                caret-color: ${COLORS.brandPrimary};
            }
            >img{
                position: absolute;
                right: 15px;
                top: 16px;
                width: 15px;
                height: 15px;
                transform: ${(p) => (p.ArrowRotate ? `rotate(180deg)` : `rotate(360deg)`)};

            }
            &&&.ui.search.selection.dropdown{
                background-color:transparent;
                &:hover{
                    border-color: ${(p) => (p.$errorBorder ? 'red' : '#000')};
                }
                border: ${(p) => (p.$errorBorder ? `solid 1px red` : `solid 1px #c4c4c4;`)}
            }
            &&&.ui.search.selection.dropdown>.text{
                height: 100%;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -webkit-appearance: none;
            }
            
            &&&.ui.search.dropdown>.text{
                top: 5px;   
                left: ${(p) => (p.$mobileStyle ? `5px` : `2px`)};
                color:#333;
                font-size: ${(p) => (p.$mobileStyle ? `14px` : `16px`)};

            }
            &&&.ui.selection.dropdown{
                cursor: pointer;
                word-wrap: break-word;
                line-height: 1em;
                white-space: normal;
                outline: 0;
                transform: rotateZ(0);
                min-width: 1em;
                height: 50px;
                background: ${COLORS.white};
                display: inline-block;
                padding: 0.8em 2.1em .1em 1em; 
                color: rgba(0,0,0,.87);
                box-shadow: none;
                border: 1px solid rgba(34,36,38,.15);
                border-radius: .28571429rem;
                transition: box-shadow .1s ease,width .1s ease;
            }
                &&&.ui.selection.dropdown .menu>.item{
                font-family: ${FONT_FAMILY.hellix.regular};
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                border:none;
                color: ${COLORS.black};
            }
            &&&.ui.selection.active.dropdown{
                border-radius: 3px;
                border: ${(p) => (p.$errorBorder ? `solid 1px #d01313` : `solid 1px #000`)};
                background-color: ${COLORS.white};
                z-index: 15;
            }
            &&&.ui.search.dropdown .menu{
                margin-top: 5px;
                border-radius: 3px;
                box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.03);
                border: solid 1px ${COLORS.lightestGrey};
                background-color: ${COLORS.white};
                overflow-y:auto;
            }
            &&&.ui.search.dropdown .menu::-webkit-scrollbar-track {
                background-color: transparent;
                -webkit-box-shadow: none;
                border-radius: 0px;
              }
              
              &&&.ui.search.dropdown .menu::-webkit-scrollbar {
                width: 8px;
                height: 8px;
                background-color: transparent;
              }
              
              &&&.ui.search.dropdown .menu::-webkit-scrollbar-thumb {
                border-radius: 20px;
                height: 50px;
                border: 2px solid;
                border-color: transparent;
                background-clip: padding-box;
                -webkit-border-radius: 20px;
                box-shadow:none;
                -webkit-box-shadow: none;
                background-color: ${COLORS.borderGrey};
              }

`;

const caseInsensitive = (query) => new RegExp(createSafeDynamicRegex(query || '').trim(), 'gi');

const caseInsensitiveEscapeSpecialChar = (query) => {
  // Escape special characters
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(escapedQuery.trim(), 'gi');
};

const phoneCode = /[+]\d*\s/g;

function inferPropsValue(value) {
  return value === undefined || value;
}

function defaultValue(values) {
  return values;
}

function sortSuggestions({ text: first }, { text: second }) {
  return first.replace(phoneCode, '').localeCompare(second.replace(phoneCode, ''));
}

function searchSuggestion(options, query, escapeSpecialCharFlag = false) {
  const regex = escapeSpecialCharFlag
    ? caseInsensitiveEscapeSpecialChar(query)
    : caseInsensitive(query);
  return options
    .filter(({ text }) => text?.toString()?.search(regex) > -1)
    .sort(({ text: first }, { text: second }) => {
      first = first?.toString();
      second = second?.toString();
      return (
        first?.search(regex) - second?.search(regex) ||
        first?.replace(phoneCode, '')?.localeCompare(second.replace(phoneCode, ''))
      );
    });
}

class CommonDropdown extends React.Component {
  httpRequest = async (url) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: url,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        const {
          multiple,
          preselect_if_one_item,
          preselect_and_disable_if_one_item,
          optional,
          appendValue
        } = this.props;
        const data = this.props.showImage
          ? this.appendImageInData(response.data.data)
          : response.data.data;
        let options = this.props.sort || false ? data.sort(sortSuggestions) : data;

        if (response.data.data[0].phone_number_validation) {
          // eslint-disable-next-line array-callback-return
          const shortenMobileCode = response.data.data.map((data) => {
            if (data.text) {
              const text = `+${parseInt(data.text.replace(/[^0-9]/g, ''), 10).toString()}`;
              return { ...data, text };
            }
          });
          options = shortenMobileCode;
        }
        // values present in this options are duplicate
        // to overcome that appending bicCode to value since its unique.
        let dropdownOptions = options;
        if (appendValue && options?.length > 0 && options[0][appendValue]) {
          dropdownOptions = options.map((obj) => {
            return {
              ...obj,
              value: obj.value + '(->' + obj[appendValue] + '<-)'
            };
          });
        }
        if (!optional || multiple || preselect_if_one_item || preselect_and_disable_if_one_item) {
          return this.setState({ options: (this.options = this.searchOptions = dropdownOptions) });
        }
        return this.setState({
          options: (this.options = defaultValue((this.searchOptions = dropdownOptions)))
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  appendImageInData = (data) => {
    return data.map((obj) => {
      //Note  :coded as mages will be directly saved in images folder only
      //Just in case if you want different path then pass path as prop
      const imageSource = this.props?.showCards
        ? cardsImage[`${obj.value}`]
        : CountryFlagName(obj.value);
      obj.image = { avatar: true, src: imageSource };
      return obj;
    });
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    const {
      multiple,
      preselect_if_one_item,
      preselect_and_disable_if_one_item,
      staticValues,
      dependedOnObject,
      url,
      optional,
      showCards
    } = nextProps;
    if (staticValues && staticValues !== this.props.staticValues) {
      const data = showCards ? this.appendImageInData(staticValues) : staticValues;
      const options = this.props.sort ? data.sort(sortSuggestions) : data;
      if (!optional || multiple || preselect_if_one_item || preselect_and_disable_if_one_item)
        this.setState({
          options: (this.options = this.searchOptions = options)
        });
      else
        this.setState({
          options: (this.options = defaultValue((this.searchOptions = options)))
        });
      return this.preSelectIfOneItem(staticValues);
    }

    if (dependedOnObject === false) return;
    if (
      dependedOnObject !== this.props.dependedOnObject &&
      url &&
      (url !== this.props.url || !this.state.options.length)
    ) {
      await this.httpRequest(url);
    }

    // If dropdown is having only one value they it will be set due to preselect_if_one_item flag
    this.preSelectIfOneItem();
  };

  componentDidMount = async () => {
    const {
      url,
      dependedOnObject,
      multiple,
      preselect_if_one_item,
      preselect_and_disable_if_one_item,
      staticValues,
      optional,
      showCards
    } = this.props;
    if (url) {
      if (dependedOnObject === false) return;
      await this.httpRequest(url);
    }
    if (staticValues) {
      //staticValues : defaultValue(staticValues, placeholder)
      const data = showCards ? this.appendImageInData(staticValues) : staticValues;
      const options = this.props?.sort ? data.sort(sortSuggestions) : data;
      if (!optional || multiple || preselect_if_one_item || preselect_and_disable_if_one_item)
        this.setState({
          options: (this.options = this.searchOptions = options)
        });
      else
        this.setState({
          options: (this.options = defaultValue((this.searchOptions = options)))
        });
    }

    // If dropdown is having only one value they it will be set due to preselect_if_one_item flag
    this.preSelectIfOneItem(staticValues);
  };

  preSelectIfOneItem = (staticValues, options = this.options) => {
    if (
      this.props.preselect_and_disable_if_one_item === true ||
      this.props.preselect_if_one_item === true
    ) {
      let disabledVals = [];
      if (options.length === 1 || (staticValues && staticValues.length === 1)) {
        let setvalue;
        if (staticValues && staticValues.length === 1) {
          setvalue = staticValues[0].value;
        } else {
          setvalue = options[0].value;
        }
        this.props.dispatch(change(this.props.formName, this.props.fieldName, setvalue));
        const { onPreFilled } = this.props;
        if (onPreFilled) {
          onPreFilled(options[0]);
        }
      } else if (
        options &&
        // eslint-disable-next-line no-prototype-builtins
        options.find((x) => x.hasOwnProperty('disabled')) &&
        (disabledVals = options.filter((x) => !x.disabled)) &&
        disabledVals.length === 1
      ) {
        //handle disabled values, if only one value is not disabled, prefilled that value
        const setvalue = disabledVals[0].value;
        this.props.dispatch(change(this.props.formName, this.props.fieldName, setvalue));
        const { onPreFilled } = this.props;
        if (onPreFilled) onPreFilled(disabledVals[0]);
      } else if (this.props.bindToThisObject && !this.props.emptyOnNotFound) {
        const found = options.find((k) => k.value === this.props.bindToThisObject);
        if (!found) {
          this.props.dispatch(change(this.props.formName, this.props.fieldName, ''));
        }
      }
    }
  };

  isDropdownDisabled = () => {
    if (this.props.preselect_and_disable_if_one_item === true && this.state.options.length === 1) {
      return true;
    } else return this.props.disabled;
  };

  handleChange = (e, data) => {
    e.preventDefault();
    const {
        onDropdownChange,
        optional,
        multiple,
        preselect_if_one_item,
        preselect_and_disable_if_one_item,
        selectOnChange
      } = this.props,
      { value } = data,
      { options } = this.state;
    this.props.onBlur(); // to close dropdown menu
    if ([].concat(value).length > 4) return e.preventDefault();
    this.value = value;
    const eventProperty = {
      section: EventItemSection.DROPDOWN,
      item: value
    };
    logEventV2(EventNamesV2.ITEM_CLICKED, eventProperty);

    if (optional && !(multiple || preselect_if_one_item || preselect_and_disable_if_one_item)) {
      this.setState({ className: 'clearable', options: this.options });
    }

    //On every change it will pass current selected json in dropdown to onDropdownChange
    let filtered = multiple
      ? options.filter((option) => value.includes(option.value))
      : options.find((option) => option.value === value);

    //This onChange function is of redux-form it takes value OR event and it will set in redux-form
    if (selectOnChange || multiple) {
      // donot reflect in redux if select on close is active
      this.props.onChange(
        this.value || (this.value !== '' ? this.props.bindToThisObject : this.value)
      );
    }
    if (filtered && filtered.phone_number_validation) {
      const key = filtered.value;
      const text = filtered.value;
      filtered = { ...filtered, key, text };
    }
    onDropdownChange && onDropdownChange(filtered);
  };

  handleClose = () => {
    const {
      onDropdownClose,
      preselect_and_disable_if_one_item,
      preselect_if_one_item,
      multiple,
      optional
    } = this.props;
    let value = this.value;
    const { options } = this.state;

    if (optional && !(preselect_if_one_item || preselect_and_disable_if_one_item)) {
      this.setState({ className: 'clearable', options: this.options });
    }

    //On every change it will pass current selected json in dropdown to onDropdownChange
    let filtered = null;
    if (multiple) {
      if (!value) value = [];
      filtered = options.filter((option) => value.includes(option.value));
    } else filtered = options.find((option) => option.value === value);

    if (!multiple) {
      this.props.onChange(
        this.value || (this.value !== '' ? this.props.bindToThisObject : this.value)
      );
    }
    onDropdownClose && onDropdownClose(filtered);
  };

  onSearchChange = (event, { searchQuery }) => {
    const text = searchQuery || '';
    this.setState({
      className: text ? '' : 'clearable',
      options: text ? this.searchOptions : this.options
    });
  };

  constructor(props) {
    super(props);
    this.state = { options: [], className: 'clearable' };
    this.options = [];
    this.searchOptions = [];
    this.value = null;
  }

  render() {
    const {
      multiple,
      bindToThisObject,
      preselect_if_one_item,
      preselect_and_disable_if_one_item,
      optional,
      onBlur,
      getOptions,
      code,
      id,
      fluid,
      placeholder,
      isSearchable,
      showLoader,
      inputRef,
      isCompact,
      isUpward,
      enableThis,
      meta,
      wasTouched,
      onFocus,
      isFocused,
      marginLeft,
      width,
      maxWidth,
      isSingleRowField,
      fieldName,
      labelClassName,
      labelText = '',
      showLabel = false,
      escapeSpecialCharFlag = false
    } = this.props;
    let value;
    if (getOptions) getOptions(code, this.state.options);
    if (preselect_and_disable_if_one_item && this.state.options.length === 1) {
      value = this.state.options[0].value;
    } else {
      // needs to be discussed with Ayesha
      if (enableThis)
        value =
          this.value ||
          (bindToThisObject ? (multiple ? [].concat(bindToThisObject) : bindToThisObject) : null);
      else
        value = bindToThisObject
          ? multiple
            ? [].concat(bindToThisObject)
            : bindToThisObject
          : null;
    }
    //redux-form untouch is not working properly due to wasTouched custom state so removed it
    const errorBorder = meta.error && meta.touched ? true : false;
    return (
      <BoxContainer
        width={width}
        maxWidth={maxWidth}
        isSingleRowField={isSingleRowField}
        $marginLeft={marginLeft}
        $chekError={errorBorder}
      >
        <Label
          $errorBorder={errorBorder}
          $isFocused={showLabel ? true : isFocused}
          value={value}
          onBlur={onBlur}
          className={labelClassName}
        >
          {showLabel && labelText ? labelText : placeholder}
        </Label>
        <OutlinedDropdown
          placeholder={showLabel && labelText ? placeholder : ''}
          name={fieldName}
          id={id}
          selection
          fluid={fluid || false}
          value={value}
          search={(options, searchQuery) =>
            inferPropsValue(isSearchable) &&
            searchSuggestion(options, searchQuery, escapeSpecialCharFlag)
          }
          loading={showLoader || false}
          options={this.state.options}
          ref={inputRef}
          onChange={this.handleChange}
          onClose={this.handleClose}
          disabled={showLoader || this.isDropdownDisabled()}
          multiple={multiple || false}
          compact={isCompact || false}
          upward={isUpward || false}
          selectOnBlur={false}
          onBlur={onBlur}
          onFocus={onFocus}
          $errorBorder={errorBorder}
          isFocused={isFocused || value}
          ArrowRotate={isFocused}
          $mobileStyle={this.props && this.props.name === 'mobile_country_code' ? true : false}
          wasTouched={wasTouched}
          onOpen={this.props.onOpen}
          onClick={this.props.onClick}
          open={this.props.open}
          icon={
            showLoader ? (
              <MiniLoader
                height="20px"
                size="20px"
                styleObj={{ position: 'absolute', bottom: '30%', right: '5%', display: 'inherit' }}
              />
            ) : (
              <img
                src={GREY_DOWN_ARROW_ICON}
                alt="dropdown"
                className="dropdown-light"
                onClick={onFocus}
              />
            )
          }
          onSearchChange={(event, data) => {
            this.props.onFocus();
            if (
              optional &&
              !(multiple || preselect_if_one_item || preselect_and_disable_if_one_item)
            ) {
              this.onSearchChange(event, data);
            }
            if (this.props.onSearchChange) {
              this.props.onSearchChange(data.searchQuery || '');
            }
          }}
        />
        {meta.touched &&
          ((meta.error && (
            <span id="error-msg" className="error">
              {' '}
              {meta.error}
            </span>
          )) ||
            (meta.warning && (
              <span id="warning-msg" className="error">
                {meta.warning}
              </span>
            )))}
      </BoxContainer>
    );
  }
}

CommonDropdown.propTypes = {
  onChange: PropTypes.func,
  bindToThisObject: PropTypes.any,
  marginLeft: PropTypes.any,
  placeholder: PropTypes.string,
  url: PropTypes.string,
  staticValues: PropTypes.array,
  onDropdownChange: PropTypes.func,
  onPreFilled: PropTypes.func,
  dependedOnObject: PropTypes.any,
  isUpward: PropTypes.bool,
  id: PropTypes.string,
  isSearchable: PropTypes.bool,
  showImage: PropTypes.bool,
  showCards: PropTypes.bool,
  getOptions: PropTypes.func,
  selectOnChange: PropTypes.bool,
  code: PropTypes.string,
  emptyOnNotFound: PropTypes.bool,
  name: PropTypes.string,
  labelText: PropTypes.string,
  showLabel: PropTypes.bool,
  //Here for dependency ,
  //two properties are created(dependedOnObject AND isDepended) as dependedOnObject can be undefined,
  //so i din't want to fire http request when dependedOnObject is undefined
  //Eg : when form loads the property on which object is depended is always undefined
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  showLoader: PropTypes.bool,
  fluid: PropTypes.bool,
  isCompact: PropTypes.bool,
  onDropdownClose: PropTypes.func,
  preselect_if_one_item: PropTypes.bool,
  preselect_and_disable_if_one_item: PropTypes.bool,
  dispatch: PropTypes.func,
  formName: PropTypes.string,
  fieldName: PropTypes.string,
  changeLabel: PropTypes.string,
  optional: PropTypes.bool,
  onBlur: PropTypes.func,
  sort: PropTypes.bool,
  inputRef: PropTypes.func,
  enableThis: PropTypes.bool,
  meta: PropTypes.any,
  wasTouched: PropTypes.bool,
  onFocus: PropTypes.func,
  isFocused: PropTypes.bool,
  width: PropTypes.bool,
  openDropdown: PropTypes.bool,
  labelClassName: PropTypes.string,
  appendValue: PropTypes.string,
  onOpen: PropTypes.func,
  escapeSpecialCharFlag: PropTypes.bool,
  maxWidth: PropTypes.string,
  isSingleRowField: PropTypes.bool,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  onSearchChange: PropTypes.func
};

export default CommonDropdown;
